export default {
  methods: {
    errorHandlingAction(error) {
      this.$logger.debug(error)
      const message = error.resultMessage
      const code = error.resultCode
      this.serverErrors.push({
        code,
        message
      })
    }
  }
}